import { NavLink } from "hooks/useCustomNavigation";
import { INTERNAL_PATHS } from "routes/paths";
import "./index.scss";

export const ReferralBanner = () => {
  return (
    <div className="referrals" data-testid="referrals-banner">
      <h3 className="referrals-banner-title">Give $5, Get $5</h3>
      <p className="referrals-banner-description">
        Refer a friend, they get $5
        <br />
        to shop and you earn $5
        <br />
        in GCX Cash.*
      </p>
      <NavLink className="referrals-anchor" to={INTERNAL_PATHS.MY_REFERRALS}>
        REFER NOW
      </NavLink>
    </div>
  );
};
